const COMPANY_CHANGED = Symbol('tenant-company-changed');

export function isCompanyChangedAbort(e: unknown): boolean {
  return typeof e === 'object' && e !== null && (e as Record<symbol, boolean>)[COMPANY_CHANGED] === true;
}

function companyChangedAbort(): Error {
  return Object.assign(new Error('company-changed'), { [COMPANY_CHANGED]: true });
}

const DEFAULT_DELAYS_MS = [0, 450, 1100] as const;

/**
 * Reexecuta em falhas transitórias (ex.: contexto de empresa/token a estabilizar após login).
 * Lança erro marcado com `isCompanyChangedAbort` se `getCurrentCompanyId()` deixar de ser `companyId`.
 */
export async function runWithTenantRetries<T>(
  companyId: string,
  getCurrentCompanyId: () => string | null,
  fn: () => Promise<T>,
  delaysMs: readonly number[] = DEFAULT_DELAYS_MS,
): Promise<T> {
  let lastError: unknown;
  for (let attempt = 0; attempt < delaysMs.length; attempt++) {
    if (attempt > 0) {
      await new Promise((r) => setTimeout(r, delaysMs[attempt]!));
    }
    if (getCurrentCompanyId() !== companyId) {
      throw companyChangedAbort();
    }
    try {
      return await fn();
    } catch (e) {
      lastError = e;
    }
  }
  throw lastError;
}
